import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Link, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import AppLogo from '../ui/AppLogo';
import { format } from 'date-fns';

const styleSheet = theme => ({
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCell: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadCellRight: {
      textAlign: 'right',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadCellWidth100: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
      width: 100
    },
    tblHeadCellRightWidth100: {
      textAlign: 'right',
      verticalAlign: 'bottom',
      borderBottom: 0,
      width: 100
    },
    tblHeadRow2: {
      height: 24,
    },
    tblHeadCell2: {
      textAlign: 'center',
      verticalAlign: 'top',
    },
    tblHeadCellRight2: {
      textAlign: 'right',
      verticalAlign: 'top',
    },
    tblCellPositive: {
      textAlign: 'right',
      color: '#006400'
    },
    tblCellNegative: {
      textAlign: 'right',
      color: 'red'
    },
    tblHeadRow3: {
      height: 32,
    },
    tblCellWidth100: {
      width: 100,
    },
    appnameitem: {
      marginLeft: 8,
    },
    [theme.breakpoints.up('sm')]: {
      tblCellDateCol: {
        paddingLeft: 10,
        paddingRight: 10,
        width: 50,
      },
      tblCellAppCol: {
        paddingLeft: 10,
        paddingRight: 10,
        minWidth: 200,
        width: 250,
      }
    },
    [theme.breakpoints.up('xs')]: {
      tblCellDateCol: {

      },
      tblCellAppCol: {

      }
    },

});

class ProfitabilityList extends React.Component {
  renderAppLinkTableCell= (appId, appName, appSku) => {

    if (!appName) {
      return '';
    }

    let aUrl = "app?appId=" + appId + "&fp=Customer";

    if (appSku != null && appSku !== '' && appSku !== appName) {
      return (
        <React.Fragment>
          <Link component="button" 
                variant="body2"
                onClick={this.goTo.bind(this, aUrl)}>
            {appName}
          </Link>
        <Typography variant="body2">{appSku}</Typography>
        </React.Fragment>
      );
    } else {
      return (
        <Link component="button" 
              variant="body2"
              onClick={this.goTo.bind(this, aUrl)}>
          {appName}
        </Link>
      );
    }
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.cl.nodes;

    //const showName = this.props.sn;

    // Get the summary data from the last entry
    let toCustSum = 0;
    let toMeSum = 0;
    let bcChargeSum = 0;
    let markupSum = 0;
    let rebateSum = 0;
    let feeSum = 0;
    let ppcSum = 0;
    let ppmSum = 0;
    let profitSum = 0;
    let lastIdx = thenodes.length-1;
    if (lastIdx >= 0)
    {
      let lastNode = thenodes[lastIdx];
      toCustSum = lastNode.toCustSum;
      toMeSum = lastNode.toMeSum;
      bcChargeSum = lastNode.bcChargeSum;
      markupSum = lastNode.markupSum;
      rebateSum = lastNode.rebateSum;
      feeSum = lastNode.feeSum;
      ppcSum = lastNode.ppcSum;
      ppmSum = lastNode.ppmSum;
      profitSum = lastNode.profitSum;
    }

    let toCustSummary = '';
    if (toCustSum > 0) {
      toCustSummary = Number(toCustSum)
        .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
    }

    let toMeSummary = '';
    if (toMeSum > 0) {
      toMeSummary = Number(toMeSum)
        .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
    }

    let bcChargeSummary = Number(bcChargeSum)
      .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
    let markupSummary = Number(markupSum)
      .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
    let rebateSummary = Number(rebateSum)
      .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
    let ttlAppBindFee = Number(feeSum)
      .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

    let ppSum = Number(ppcSum) + Number(ppmSum);
    let ttlPPFee = Number(ppSum)
      .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

    let netSummary = Number(profitSum)
      .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
    let netSummaryClass = classes.tblCellPositive;

    if (profitSum < 0) {
      let negSummary = -1 * profitSum;
      netSummary = '(' + Number(negSummary).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
      netSummaryClass  = classes.tblCellNegative;
    } else {
      if (netSummary === '-$0.00') {
        netSummary = '$0.00';
      }
    }

    // props.theRole is "reseller" or "customer"
    // props.thePage is "custCharge" or "myCharges"

    let keyCounter = 1;
    return (
      <div className={classes.paper}>
      <TableContainer>
          <Table>
            <TableHead className={classes.tblHead}>
              <TableRow className={classes.tblHeadRow}>
                <TableCell colSpan={3} className={classes.tblHeadCell}/>
                <TableCell className={classes.tblHeadCellRight}>App&nbsp;charge</TableCell>
                <TableCell className={classes.tblHeadCellRight}>Markup</TableCell>
                <TableCell colSpan={2} className={classes.tblHeadCell}>Fees</TableCell>
                <TableCell colSpan={2} className={classes.tblHeadCell}>Total billed</TableCell>
                <TableCell className={classes.tblHeadCellRight}>Rebate</TableCell>
                <TableCell className={classes.tblHeadCellRight}>Profit</TableCell>
              </TableRow>
              <TableRow className={classes.tblHeadRow2}>
                <TableCell className={classes.tblHeadCell} colSpan={3}/>
                <TableCell colSpan={2}/>
                <TableCell className={classes.tblHeadCellRight2}>AppBind</TableCell>
                <TableCell className={classes.tblHeadCellRight2}>CC</TableCell>
                <TableCell className={classes.tblHeadCellRight2}>Customer</TableCell>
                <TableCell className={classes.tblHeadCellRight2}>Me</TableCell>
                <TableCell colSpan={2}/>
              </TableRow>
              <TableRow className={classes.tblHeadRow3}>
                <TableCell className={classes.tblCellDateCol}>Date</TableCell>
                <TableCell className={classes.tblCellAppCol}>Customer</TableCell>
                <TableCell className={classes.tblCellAppCol}>App</TableCell>
                <TableCell align="right"><Typography variant="subtitle2">{bcChargeSummary}</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2">{markupSummary}</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2">{ttlAppBindFee}</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2">{ttlPPFee}</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2">{toCustSummary}</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2">{toMeSummary}</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2">{rebateSummary}</Typography></TableCell>
                <TableCell className={netSummaryClass}>{netSummary}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { thenodes.map(n => {
                // Is the charge pending?  If transaction id is null, that's the case
                let pending = false;
                if (n.transactionId == null) {
                  pending = true;
                }

                //transaction time is non-zoned, specify as UTC
                let tdate = format(new Date(n.transactionTime+'Z'), 'yyyy-MM-dd');
                let bcc = Number(n.bindCardCharge)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                let mName = '';
                if (n.mName != null && n.mName !== "null") {
                  mName = "Merchant identifier: " + n.mName;
                }
                let mkp = '';
                if (n.markup !== 0 && pending === false)
                {
                  mkp = Number(n.markup)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                }
                let rebate = '';
                if (n.rebate > 0)
                {
                  rebate = Number(n.rebate)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                }
                //let theAppStatus = n.customerAppStatus;
                /*let bcStatus = n.bcStatus;
                let theLast4 = n.bcLast4;
                if (bcStatus === 2)
                  theLast4 = '*' + theLast4 + '*';*/

                /* payment info is in a child object */
                /*
                let billedCustomer = Number(0)
                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                let billedYou = Number(0)
                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                */
                let billToCust = 0;
                let billToMe = 0;
                let ppFeeCust = 0;
                let ppFeeRes = 0;
                let ppFeeTot = 0;

                let thePayments = n.payments;
                if (thePayments != null && thePayments.length > 0)
                {
                  for (let i=0; i<thePayments.length; i++)
                  {
                    if (thePayments[i].psAccountId === n.customerAccountId)
                    {
                      billToCust = Number(billToCust) + Number(thePayments[i].paidAmount);
                      ppFeeCust = Number(ppFeeCust) + Number(thePayments[i].ppAmount);
                    }
                    else if (thePayments[i].psAccountId === n.provisioningAccountId)
                    {
                      billToMe = Number(billToMe) + Number(thePayments[i].paidAmount);
                      ppFeeRes = Number(ppFeeRes) + Number(thePayments[i].ppAmount);
                    }
                  }
                }

                // let totalBilled = Number(billToCust) + Number(billToMe);
                let billedToCust = '';
                let failedToCust = '';
                if (billToCust > 0 && pending === false)  {
                  billedToCust = Number(billToCust)
                                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                } else if (billToCust === 0 && n.paymentOrder === 0 && pending === false && n.profit < 0) {
                  // This means that we haven't been able to bill the customer.  Show an amount equal to the
                  // profit number.
                  let negProfit = -1 * n.profit;
                  // failedToCust = '(' + Number(negProfit).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  failedToCust = Number(negProfit).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                }

                let billedToMe = '';
                let backupDunningNeeded = false;
                if (billToMe > 0 && pending === false) {
                  billedToMe = Number(billToMe)
                                .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                  if (n.paymentOrder !== 2) {
                    // Reseller covering the customer; will need backup dunning
                    backupDunningNeeded = true;
                  }
                }

                let appBindFee = '';
                let ppFee = '';

                if (pending === false) {
                  ppFeeTot = Number(ppFeeCust) + Number(ppFeeRes);
                  appBindFee = Number(n.appbindFee)
                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                  ppFee = Number(ppFeeTot)
                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                }
                /*
                let feeTot = Number(n.appbindFee) + Number(ppFeeTot);
                let fee = Number(feeTot)
                .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                */

                let netToMe = '';
                let netToMeClass  = classes.tblCellPositive;
                if (Number(n.markup) > 0 && pending === false)
                {
                  if (n.profit < 0) {
                    let negProfit = -1 * n.profit;
                    netToMe = '(' + Number(negProfit).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                    netToMeClass  = classes.tblCellNegative;
                  } else {
                    netToMe = Number(n.profit).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                  }
                }

                /*
                let received = Number(n.receivedAmount)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                */

                let theKey = n.customerAppId + '-' + n.transactionTime + '-' + keyCounter++;
                return (
                  <TableRow key={theKey}>
                    { pending === true &&
                    <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellDateCol}><i>{tdate}</i></TableCell>}
                    { pending === false &&
                    <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellDateCol}>{tdate}</TableCell>}
                    <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellDateCol}>{n.customerAccountName}</TableCell>
                    <TableCell colSpan={1} className={classes.tblCellAppCol}>
                      <Grid container alignItems="center">
                        <Grid item>
                          <AppLogo logoPath={n.appLogo} appName={n.appName} imageHeight='24px'/>
                        </Grid>
                        <Grid item className={classes.appnameitem}>
                          <Typography variant="subtitle2">{this.renderAppLinkTableCell(n.appId, n.appName, n.appSku)}</Typography>
                        </Grid>
                      </Grid>
                    </TableCell>
                    { pending === true &&
                    <TableCell align="right"><Tooltip title={mName} interactive="true" placement="right"><div><i>{bcc}</i></div></Tooltip></TableCell>}
                    { pending === false &&
                    <TableCell align="right"><Tooltip title={mName} interactive="true" placement="right"><div>{bcc}</div></Tooltip></TableCell>}
                    <TableCell align="right">{mkp}</TableCell>
                    <TableCell align="right">{appBindFee}</TableCell>
                    <TableCell align="right">{ppFee}</TableCell>
                    { failedToCust === '' &&
                    <TableCell align="right">{billedToCust}</TableCell>}
                    { failedToCust !== '' &&
                    <TableCell align="right"><Tooltip title="Your customer's payment method for this charge was declined."><div><i>{failedToCust}</i></div></Tooltip></TableCell>}
                    { backupDunningNeeded === false &&
                    <TableCell align="right">{billedToMe}</TableCell>}
                    { backupDunningNeeded === true &&
                    <TableCell align="right"><Tooltip title="You covered the cost of this subscription on behalf of your customer when your customer's payment method was declined. We'll attempt to recover this cost for you when your customer's payment issues are resolved."><div><i>{billedToMe}</i></div></Tooltip></TableCell>}
                    <TableCell align="right">{rebate}</TableCell>
                    <TableCell className={netToMeClass}>{netToMe}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );

  } // end render()
}

ProfitabilityList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(ProfitabilityList), { cl: graphql`
  fragment ProfitabilityList_cl on BindCardCustomerChargeWSumsConnection {
    nodes {
      toCustSum
      toMeSum
      bcChargeSum
      markupSum
      feeSum
      ppcSum
      ppmSum
      profitSum
      rebateSum
      bcId
      bcLast4
      bcStatus
      customerAccountId
      customerAccountName
      customerAppId
      paymentOrder
      customerAppStatus
      provisioningAccountId
      appId
      appName
      appSku
      appLogo
      transactionId
      transactionTime
      bindCardCharge
      mName
      markup
      appbindFee
      profit
      rebate
      payments {
        paidId
        extSource
        extTransactionId
        paidAmount
        ppAmount
        psId
        psAccountId
        psCcBrand
        psCcLast4
        receivedAmount
      }
    }
  }
`});
